export default () => {
    'use strict';
    function copyURL(button: HTMLElement) {
        const tooltip = new window.bootstrap.Tooltip(button, { trigger: 'manual' });
        navigator.clipboard.writeText(window.location.href);
        if (tooltip) {
            tooltip.show();
            setTimeout(() => {
                tooltip.hide();
            }, 2000)
        }

    }

    function initEvents(button: HTMLElement) {
        button.addEventListener('keydown', function (event) {
            const code = event.code;
            if (code === 'Space') {
                copyURL(button);
            }
        });
        button.addEventListener('click', function (event) {
            copyURL(button);
        });
    }

    document.querySelectorAll('[role="copyURL"]').forEach(button => {
        const htmlButton = button as HTMLElement
        initEvents(htmlButton);
    })
}
